import { STRIKING_DRILL_TYPES } from '../../../data/constants';
import { useToast } from '../../../context/ToastContext';
import { numericProps } from '../../../utils/numericInput';

export default function StrikingDrillsEditor({ drills, onChange }) {
    const showToast = useToast();
    const add = () => onChange([...drills, { type: '', minutes: '' }]);
    const remove = i => onChange(drills.filter((_, idx) => idx !== i));
    const update = (i, key, val) => onChange(drills.map((d, idx) => idx === i ? { ...d, [key]: val } : d));

    return (
        <>
            {drills.map((d, i) => (
                <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
                    <select className="form-input" style={{ flex: 1 }}
                        value={d.type || ''}
                        onChange={e => update(i, 'type', e.target.value)}>
                        <option value="">드릴 종류</option>
                        {STRIKING_DRILL_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                    <input className="form-input" placeholder="분" style={{ width: 64, padding: 8 }}
                        {...numericProps(d.minutes || '', v => update(i, 'minutes', v), showToast)} />
                    <span style={{ fontSize: 12, color: 'var(--text3)' }}>분</span>
                    <button className="remove-btn" onClick={() => remove(i)}>×</button>
                </div>
            ))}
            <button className="add-set-btn" style={{ width: '100%' }} onClick={add}>+ 드릴 추가</button>
        </>
    );
}
